import { Container, Button, ListGroup } from 'react-bootstrap';
import { NavLink, Link, useHistory } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import './UsersManuals.css';
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import { getAllInstructManual, loadFilesContent } from "../../services/RequestsToServer";


function UsersManuals() {
    const [files, setFiles] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null); // Зберігаємо обраний файл
    const [zoom, setZoom] = useState(1); // Для керування масштабом
    const [error, setError] = useState(null);
    const history = useHistory();

     // Завантаження списку файлів із бекенду
    useEffect(() => {
        const fetchFiles = async () => {
        try {
            const response = await getAllInstructManual();
            if(response.status === 200) {
              setFiles(response.data);
              setError(null);
            } else {
              setError(response);
            }
        } catch (error) {
            console.error('Error:', error);
        }
        };
        fetchFiles();
    }, []);

      const loadFileContent = (file) => {
        const obj = loadFilesContent(file);
        if (typeof obj === "object" && obj !== null) {
        // Скидаємо selectedFile перед встановленням нового, щоб змусити оновлення
            setSelectedFile(null);
          setTimeout(() => {
            setSelectedFile(obj);
        }, 0);
        } else {
          setError(String(obj));
        }
      };

  return (
    <Container className='ManualsWrapper'>
        {error && <div className="alert alert-danger">{error}</div>}
    <div className='titleBtnWrapper'>
    <Button className='btn btn-secondary btnBackManuals' onClick={() => history.goBack()}>Назад</Button>
    <h5 className='titleContainerManualsStyle'>Посібники</h5>
    </div>
    <hr className='mb-4'></hr>
        <Row className='row-1 row-xl-1 row-lg-1 row-md-1 row-sm-2'>
            <Col className='col-12 col-xl-3 col-lg-3 col-md-12 col-sm-12 borderRightManuals'>
                <div className='StyleColumnManuals'>
                    <h5 className='titleColumnList'>Список посібників</h5>
                        <ListGroup>
                         {files.filter((f) => f.type === "manual")
                         .map((file) => (
                            <ListGroup.Item
                            key={file.id}
                            action
                            onClick={() => loadFileContent(file)}
                            className="instruction-item"
                            >
                            {file.name}
                            </ListGroup.Item>
                            ))}
                        </ListGroup>
                </div>
            </Col>
            <Col className='col-12 col-xl-9 col-lg-9 col-md-12 col-sm-12'>
                <div className='StyleColumnManuals'>
                    {!selectedFile ? 
                    <h5 className='titleColumnView'>Перегляд</h5>
                        :
                    <h5 className='titleColumnView'>{selectedFile.customName}</h5>
                        
                    }
                    <div className="viewer-container">
                    {selectedFile ? (
                      <DocViewer
                      key={selectedFile.timestamp || selectedFile.uri}
                      documents={[selectedFile]}
                      pluginRenderers={DocViewerRenderers}
                      className="doc-viewer-custom"
                      // style={{ height: '100%', border: '1px solid #ccc' }}
                      config={{
                      header: {
                      disableFileName: true,
                      retainURLParams: false,
                      },
                      pdfZoom: {
                      defaultZoom: zoom,
                      zoomJump: 0.2,
                      },
                      }}
                      onDocumentLoad={() => console.log('Документ завантажено')}
                      />
                      ) : (
                      'Виберіть посібник зі списку'
                    )}
                    </div>
                </div>
            </Col>
        </Row>

    </Container>
  );
}

export default UsersManuals;
